export const PROTECTIONPLAN_ON_CHANGE = 'PROTECTIONPLAN_ON_CHANGE';
export const PROTECTIONPLAN_ON_RESET = 'PROTECTIONPLAN_ON_RESET';
